export default __webpack_public_path__ + "images/934722d22d94ef73fbc3e6a4f72942a2-mindfulness-for-emotional-balance.svg";